import { render } from "./AppointmentSuggestions.vue?vue&type=template&id=54af1016&ts=true"
import script from "./AppointmentSuggestions.vue?vue&type=script&lang=ts"
export * from "./AppointmentSuggestions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__